const key = (portalId: string) => `cpb-${portalId}-preview-client-id`;

export function getStoredPreviewClientId(portalId: string): number | null {
  const raw = window.localStorage.getItem(key(portalId));
  const n = raw ? Number(raw) : NaN;
  return Number.isFinite(n) ? n : null;
}

export function setStoredPreviewClientId(portalId: string, itemId: number) {
  window.localStorage.setItem(key(portalId), String(itemId));
}
